import React from 'react';
import { useCategoryAnalysis } from './context/CategoryAnalysisContext';
import './style/keywordTags.scss';
import { Info } from 'lucide-react';
import { useAnalytics, ANALYTICS_EVENTS } from '../../analytics';

const KeywordTags = () => {
  const {
    keywords,
    activeKeyword,
    setActiveKeyword,
    keywordsLoading,
    keywordsError,
    platform,
  } = useCategoryAnalysis();
  const { trackEvent } = useAnalytics();

  const handleKeywordClick = (keyword) => {
    trackEvent(ANALYTICS_EVENTS.FEATURE.CATEGORY_SEARCH, { genre: keyword, platform, source: "suggested_chip" })
    setActiveKeyword(keyword)
  };


  // Capitalize only the first letter of a keyword (leave rest as-is)
  const capitalizeFirst = (s) => {
    if (s === undefined || s === null) return '';
    const str = String(s).trim();
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // Skeleton for keyword tags
  const renderSkeleton = () => (
    <div className="keyword-tags">
      {Array.from({ length: 7 }).map((_, index) => (
        <div key={index} className="keyword-tag-skeleton"></div>
      ))}
    </div>
  );

  // Error state
  if (keywordsError) {
    return (
      <div className="keywords-section">
        <h3>Words Commonly used</h3>
        <div className="keyword-error">
          <p>Failed to load keywords. Please try again later.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="keywords-section">
      <h2 className="publisher-intel-title" style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.8)' }}>Commonly Searched Genres</h2>
      {keywordsLoading ? (
        renderSkeleton()
      ) : (
        <div
          className="keyword-tags"
          style={{ position: 'relative' }}
        >
          {/* Hardcoded keywords */}
          {/* {['Action', 'Adventure', 'Sports', 'Puzzle', 'Racing', 'Simulation'].map((keyword) => (
            <span
              key={keyword}
              className={`keyword-tag ${activeKeyword === keyword ? 'active' : ''}`}
              onClick={() => setActiveKeyword(keyword)}
            >
              {capitalizeFirst(keyword)}
            </span>
          ))} */}

          {/* Old code - using keywords from API */}
          {keywords.map((keyword) => (
            <span 
              key={keyword}
              className={`keyword-tag ${activeKeyword === keyword ? 'active' : ''}`}
              onClick={() => handleKeywordClick(keyword)}
            >
              {capitalizeFirst(keyword)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default KeywordTags;
